import { io } from 'socket.io-client';

const socketUrl = (window.__env__ && window.__env__.VUE_APP_WEBSOCKET_URL) || process.env.VUE_APP_WEBSOCKET_URL;

class SocketService {
  constructor() {
    this.socket = null;
  }

  connect() {

    this.socket = io(socketUrl);

    this.socket.on('connect', () => {
      console.log('✅ Socket conectado:', this.socket.id);
    });

    this.socket.on('disconnect', () => {
      console.log('🔌 Socket desconectado');
    });
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}

export default new SocketService();